module.exports = __webpack_public_path__ + "img/sample-collection.24df7f4.png";